export default __webpack_public_path__ + "static/media/NewInstallation.37f773b4.svg";